import { Injectable } from '@angular/core';
import { SwUpdate, VersionReadyEvent } from '@angular/service-worker';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { filter, map, takeUntil } from 'rxjs/operators';
import { Platform } from '@angular/cdk/platform';
import { BaseComponent } from '../../core/base.component';
import { NewAppVersionNotificationComponent } from '../../ui/new-app-version-notification';

@Injectable({
  providedIn: 'root',
})
export class PwaService extends BaseComponent {
  private promptEvent: any;

  constructor(
    private platform: Platform,
    private swUpdate: SwUpdate,
    private bottomSheet: MatBottomSheet
  ) {
    super();

    this.swUpdate.versionUpdates
      .pipe(
        filter((evt): evt is VersionReadyEvent => evt.type === 'VERSION_READY'),
        map((evt) => ({
          type: 'UPDATE_AVAILABLE',
          current: evt.currentVersion,
          available: evt.latestVersion,
        })),
        takeUntil(this.componentDestroyed)
      )
      .subscribe(() =>
        this.bottomSheet.open(NewAppVersionNotificationComponent)
      );
  }

  public async init() {
    if (this.platform.isBrowser) {
      window.addEventListener('beforeinstallprompt', (event: any) => {
        event.preventDefault();
        this.promptEvent = event;
      });
    }
  }

  public installPwa(): void {
    if (this.promptEvent) {
      this.promptEvent.prompt();
    }
  }

  // TODO: do not display this component if already in app
  public shouldDisplayPwaDownload(): boolean {
    // TODO: Find the way to trigger download on Ios. In worst case -> release new ionic app and optimize URL parameter mechanismus
    return false;
  }
}
